import React, { useEffect, useMemo, useState } from "react"
import { changeThemeFunction, checkIsSp } from "utils/util"
import APIs from "redux/apis"
import { UserStorage } from "utils/userStorage"
import { changeColor } from "redux/ducks/Setting"
import {
  defaultData,
  indexDataList,
  loginErrorResult,
  requestParam,
} from "components/pages/others/external/const"
import { map, get, includes, filter, find, merge, cloneDeep } from "lodash"
import { requestParamType } from "components/pages/others/external/utils"
import { CreateIndexContents } from "components/pages/others/external/market"
import { APIResponse } from "redux/apis/types"
import { useDispatch } from "react-redux"
import { resultObj } from "components/atoms/chart/logic/chartProvider"
import ClassNames from "classnames"
import { Config } from "config/config"

export const ExternalHome = () => {
  const [indexData, setIndexData] = useState<Array<resultObj>>([defaultData])
  const [mask, setMask] = useState(false)

  const dispatch = useDispatch()

  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])

  setInterval(function() {
    postSize()
  }, 100)

  const postSize = () => {
    window.parent.postMessage(
      document.getElementById("root").clientHeight,
      Config.api.iframeTargetOriginHome
    )
  }
  const callApi = async (
    params: Array<requestParamType>,
    setData: Function
  ) => {
    const res: APIResponse.Res = await Promise.all(
      map(params, async param => {
        const delayChartData = await APIs.Chart.DelayChart({
          ...param,
          LegType: "1D",
        })
        const _indexData = find(indexDataList, { Symbol: get(param, "Symbol") })
        const _delayChartData = cloneDeep(delayChartData)
        merge(get(_delayChartData, "Symbol"), _indexData)
        return _delayChartData
      })
    )
    setData(res)
  }

  useEffect(() => {
    ;(async () => {
      const res = await APIs.Account.OpenLogin()
      if (get(res, "Result") === 0) {
        setMask(false)
        await UserStorage.User.set(res)
        const htmlClass = document.querySelector("html").classList
        if (includes(htmlClass, "dark")) {
          ;(async () => {
            await dispatch(changeColor())
            dispatch(changeThemeFunction())
          })()
        }
        const _requestParam = filter(requestParam, (data: object) => {
          return includes(["101", "HSI", "SSEC", "VNI"], get(data, "Symbol"))
        })
        callApi(_requestParam, setIndexData)
      }
      //ログインができない時間帯(2時から6時の間)はマスクをかけて触れないようにする。
      if (get(res, "Result") === loginErrorResult) {
        setMask(true)
      }
    })()
  }, [])

  return (
    <div className="external-contents">
      {mask && <div className="mask">現在チャートは表示できません</div>}
      <ul
        className={ClassNames(
          "chart-list-contents chart-list thin chart-mini-contents home",
          { sp: isPhone }
        )}
      >
        {map(indexData, (data: resultObj, key: number) => {
          return <CreateIndexContents key={key} data={data} headerOnly={true} />
        })}
      </ul>
    </div>
  )
}
